import { render, staticRenderFns } from "./MonthlyProfessionalFollowUpReport.vue?vue&type=template&id=b50a67a0&"
import script from "./MonthlyProfessionalFollowUpReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyProfessionalFollowUpReport.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyProfessionalFollowUpReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports